import { Box, FormControl, Stack, TextField, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { projectColors } from 'data/static';
import { FC } from 'react';
import { UseFormReturn } from 'react-hook-form';

export type TAddEditNewProjectForm = {
  name: string;
  color: string;
  description?: string | null;
};

type TAddEditNewProjectFormProps = Pick<
  UseFormReturn<TAddEditNewProjectForm>,
  'formState' | 'register' | 'watch' | 'setValue'
> & {
  onSubmit: () => void;
};

const AddEditNewProjectForm: FC<TAddEditNewProjectFormProps> = ({
  formState,
  register,
  watch,
  setValue,
  onSubmit,
}) => {
  const { errors } = formState;
  const selectedColor = watch('color');

  return (
    <FormControl component="form" fullWidth onSubmit={onSubmit}>
      <Stack spacing={3} direction="column">
        <TextField
          autoFocus
          label="Project name"
          variant="outlined"
          error={!!errors.name}
          helperText={errors.name && errors.name.message}
          required
          placeholder="e.g. Marketing Campaign"
          {...register('name')}
        />
        <TextField
          label="Description (optional)"
          variant="outlined"
          error={!!errors.description}
          helperText={errors.description && errors.description.message}
          multiline
          inputProps={{
            maxLength: 100,
          }}
          rows={2}
          placeholder="A brief description of this project..."
          {...register('description')}
        />
        <Box>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 500,
              color: 'text.secondary',
              mb: 1.5,
            }}
          >
            Color
          </Typography>
          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
            {projectColors.map(color => (
              <Box
                key={color.dark}
                onClick={() => setValue('color', color.light)}
                sx={{
                  width: 36,
                  height: 36,
                  borderRadius: 2,
                  backgroundColor: color.dark,
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'transform 0.15s, box-shadow 0.15s',
                  border: '2px solid',
                  borderColor: selectedColor === color.light ? 'white' : 'transparent',
                  boxShadow: selectedColor === color.light
                    ? `0 0 0 2px ${color.dark}`
                    : 'none',
                  '&:hover': {
                    transform: 'scale(1.1)',
                  },
                }}
              >
                {selectedColor === color.light && (
                  <CheckIcon sx={{ color: 'white', fontSize: 18 }} />
                )}
              </Box>
            ))}
          </Box>
        </Box>
      </Stack>
    </FormControl>
  );
};

export default AddEditNewProjectForm;
